import * as React from 'react';
import { Box } from '@mui/material';

interface IProps {
    validateForm: () => void;
    initialValues: any;
    formValues?: any;
}

export const FormikModifierWrapper: React.FC<React.PropsWithChildren<IProps>> = ({
    children,
    initialValues,
    validateForm,
    formValues
}) => {
    React.useEffect(() => {
        validateForm();
    }, [initialValues, validateForm, formValues]);

    return (
        <Box height="0" display="flex" flex={1}>
            {children}
        </Box>
    );
};
